import { createContext } from "react";

const ContentTypeContext = createContext();

export default ContentTypeContext;

export const ViewContextProvider = ContentTypeContext.Provider;
